import React, {Component} from 'react';
import {Button} from 'reactstrap';
import SmartDialog from "../SmartDialog/SmartDialog";
import FormRenderer from "../../common/FormRenderer/FormRenderer";
import {ic_feedback} from 'react-icons-kit/md/ic_feedback';
import Icon from 'react-icons-kit';
import MDProgress from 'react-md-progress-bar';
import TTLProxy from "../../common/TTLAsyncProxy";
import HTML from '../../common/HtmlHelpers';
import {FeedbackEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'


const Categories = [
  "Tractor Requests & Services",
  "Operations",
  "Technical",
  "Tractor Tracking (GPS Trackers)",
  "User Experience",
  "Finance",
  "Communications",
  "Other"
];

class FeedbackDialog extends Component{

    constructor(props){
        super(props);
        this.state = this.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    getInitialState(){
        return {
            isBusy: false
        }
    }

    onSubmit({ title , message }){

        const proxy = this.proxy;

        this.setState({
            isBusy: true
        });

        return proxy.processRequest( FeedbackEndpoints.submitFeedback({
            title,
            message: Utils.htmlToMarkdown(message)
        }) ).then(response => {

            this.setState({
                isBusy: false
            });

            //
            HTML.toastMessage("Thanks for the feedback!");

            //
            this._dlg.toggle();

        }).catch(err => {

            HTML.toastWarning( Utils.getResponseError(err) );

            //
            this.setState({
                isBusy: false
            });

        });


    }

    show(){

        //
        this.setState(this.getInitialState());

        //
        this._dlg.show();
    }

    render(){

        const inputs = [
            {
                name: "title" , title: "Category" , type: "select" ,  required: true,
                items: Categories.map(x => ({ text: x , value: x }))
            },
            {
                name: 'message' , title: 'Message' , type: 'custom', noFrame: true, required: true,
                render: ({ field , form: { setFieldValue   } }) => {

                       return <ReactQuill {...field}
                                       placeholder={"Enter feedback message"}
                                       style={{
                                           height: '18em',
                                           maxHeight: '18em',
                                           marginBottom: '4em'
                                       }}
                                       onChange={(value,delta,source,editor) => {
                                           setFieldValue(field.name,editor.getLength() > 1 ? value : '');
                                       }}/>
                }
            }
        ];

        const state = this.state;

        return <SmartDialog title={<span><Icon icon={ic_feedback} size={24}/> Submit Feedback</span>} ref={r => this._dlg = r}>

                <FormRenderer inputs={inputs}
                              initialValues={{ title: Categories[0] , message: '' }}
                              onSubmit={this.onSubmit.bind(this)}
                              busy={state.isBusy}>
                    {({ isValid }) => {

                        return <React.Fragment>
                            <hr/>
                            {state.isBusy && <MDProgress overlay={true} show={true}/>}
                            <Button disabled={!isValid} style={{ width: "100%" }} color={"green"}>Submit Feedback <i className="fa fa-check"></i></Button>
                        </React.Fragment>

                    }}

                </FormRenderer>

        </SmartDialog>

    }
}

export default FeedbackDialog;


// WEBPACK FOOTER //
// ./src/components/FeedbackDialog/FeedbackDialog.js